<div class="container media-articles mt-6 md:mt-20 mb-20">
  <div class="tabs">
    @for (tab of tabs; track $index) {
    <button [class.active]="activeTabIndex === $index" (click)="setActiveTab($index)" class="tab-button">
      {{tab.label}}
    </button>
    }
  </div>

  <div class="accordion mt-10">
    @for (month of getUniqueMonths(); track month) {
    @if (getArticlesByMonth(month).length > 0) {
    <div class="month-section">
      <div class="month-header" (click)="toggleMonth(month)">
        <h3>{{month}}</h3>
        <img src="assets/images/down-arrow.svg" alt="Toggle" class="toggle-icon"
          [class.expanded]="isMonthExpanded(month)">
      </div>

      @if (isMonthExpanded(month)) {
      <div class="month-content">
        @for (article of getArticlesByMonth(month); track article.title) {
        <div class="article">
          @if(article.mediaType == 'Video'){
          <div class="article__videoThumbnail relative cursor-pointer" title="Play Video">
            <img [src]="article.image_url" [alt]="article.alt_text || article.title">
            <button (click)="handler__video(article.link)" class="button-play" type="button" title="Play Video"><span
                class="sr-only">Play</span></button>
          </div>
          <div class="article-content flex items-center gap-4 md:gap-8 justify-between w-full flex-wrap md:flex-nowrap">
            <div>
              <div class="bg-[#F9F8F0] flex w-fit text-[13px] text-[#666666] px-2 py-1 gap-4">
                <div [innerHTML]="article.batch"
                  class="md:block truncate overflow-hidden whitespace-nowrap text-ellipsis w-[175px] md:w-full"></div>
              </div>
              <a href="javascript:void(0)" class="text-[#333333] mt-4 inline-block"
                (click)="handler__video(article.link)">
                <h4 class="line-clamp-2 md:line-clamp-none">
                  {{article.title}}</h4>
              </a>
              <p class="date mb-0 mt-3">{{article.date}}</p>
            </div>
            <a href="javascript:void(0)" (click)="handler__video(article.link)"
              class="button button-arrow text-14 !px-4 !py-2 !min-w-[152px] border border-[#333333] !rounded-[100px] text-center text-[#333333] ">Watch
              Now</a>
          </div>
          }
          @else{
          <a [href]="article.link" target="_blank">
            <img [src]="article.image_url" [alt]="article.alt_text || article.title">
          </a>
          <div class="article-content flex items-center gap-4 md:gap-8 justify-between w-full flex-wrap md:flex-nowrap">
            <div class="">
              <div class="bg-[#F9F8F0] flex w-fit text-[13px] text-[#666666] px-2 py-1 gap-4">
                <div [innerHTML]="article.batch"
                  class="md:block truncate overflow-hidden whitespace-nowrap text-ellipsis w-[175px] md:w-full">
                </div>
              </div>
              <a [href]="article.link" target="_blank" class="text-[#333333] mt-4 inline-block">
                <h4 class="text-[#333333] line-clamp-2 md:line-clamp-none">
                  {{article.title}}
                </h4>
              </a>
              <p class="date mb-0 mt-3">{{article.date}}</p>
            </div>
            <a [href]="article.link" target="_blank"
              class="button button-arrow text-14 !px-4 !py-2 !min-w-[152px] border border-[#333333] !rounded-[100px] text-center text-[#333333] ">Read
              More</a>
          </div>
          }

        </div>
        }
      </div>
      }
    </div>
    }
    }
  </div>
</div>
@defer (when currentVideoUrl) {
<app-video-popup [videoURL]='currentVideoUrl'></app-video-popup>
}